import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'PHASE',
  of: {
    tournament: { get: 'phase' },
  },
});
